import axios from "axios";
import QS from "qs";
import Vue from "vue";

axios.defaults.timeout = 10000000; //请求超时5秒
if (process.env.NODE_ENV == "development") {
  //开发环境
  axios.defaults.baseURL = "/api";
} else if (process.env.NODE_ENV == "production") {
  //生产环境
  axios.defaults.baseURL = "";
}
var conferenceId = "";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded"; //设置post请求是的header信息
axios.defaults.withCredentials = true; // 如果你要用到session验证码功能，让请求携带cookie
axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
let instance = axios.create({
  headers: { "content-type": "multipart/form-data" }
});
//http request 拦截器
axios.interceptors.request.use(
  config => {
    const AUTH_TOKEN =
      process.env.NODE_ENV === "production"
        ? Vue.$cookies.get("member_token")
        : sessionStorage.getItem("token");
    if (AUTH_TOKEN) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers["Authorization"] = AUTH_TOKEN;
    }
    config.headers.developsign = "1fa4af77a26c7d33070ba4d7de148b78";
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
axios.interceptors.response.use(
  function(response) {
    if (response.data.code === 302) {
      window.location.href = Vue.$cookies.get("login_url");
    } else if (response.data.code === 301) {
      window.location.href = Vue.$cookies.get("login_url");
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = (url, params) => {
  if (sessionStorage.getItem("conferenceId")) {
    conferenceId = sessionStorage.getItem("conferenceId");
  } else {
    conferenceId = "";
  }
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: {
          t: Date.parse(new Date()),
          conferenceId: conferenceId,
          ...params
        }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
};
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = (url, params) => {
  if (sessionStorage.getItem("conferenceId")) {
    conferenceId = sessionStorage.getItem("conferenceId");
  } else {
    conferenceId = "";
  }
  var paramss = {
    conferenceId: conferenceId,
    ...params
  };
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(paramss))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
};
/**
 * delet方法，对应delett请求
 * @param {String} url [请求的url地址]
 * delete关键字会和vue系统关键字冲突，所以这里用delet代替
 * delete用于删除，参数一般带在url
 */
export const delet = (url, params) => {
  if (sessionStorage.getItem("conferenceId")) {
    conferenceId = sessionStorage.getItem("conferenceId");
  } else {
    conferenceId = "";
  }
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: {
          t: Date.parse(new Date()),
          conferenceId: conferenceId,
          ...params
        }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
};
/**
 * patch方法，对应patch请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 这里根据需求适应了formdata的格式，也可以跟post用一样的封装
 */
export const patch = (url, params) => {
  // 将数据转换为formData格式
  // 正常情况下可以直接使用参数对象进行patch，如果出错可以尝试转换form Data
  var formData = new FormData();
  formData.append("account", params.account);
  formData.append("password", params.password);
  return new Promise((resolve, reject) => {
    axios
      .patch(url, formData)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
};
/**
 * 封装post请求 FormData方式
 * @param url
 * @param data
 * @returns {Promise}
 */
export const postform = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    instance.post(url, data).then(
      res => {
        resolve(res.data);
      },
      err => {
        reject(err.data);
      }
    );
  });
};
